import { DateTime } from 'luxon';

import { CarrierRef, Mode, TenderMethod } from '@rygen/rygen-ui/model';
import { loadLuxonDateTime } from '@rygen/rygen-ui/util';

import { Carrier } from '../Carrier';

import { TenderResponse } from './TenderResponse';
import { TenderStatus } from './TenderStatus';

export class TenderRequest {
  shipmentId?: number;
  rateQuoteId?: number;
  tenderMethod: TenderMethod = TenderMethod.MANUAL;
  tenderConfigOptions?: any;
  tenderResponse?: TenderResponse;
  expirationDate?: DateTime;
  status?: TenderStatus;
  carrier?: Carrier;
  brokeredCarrier?: CarrierRef;
  mode?: Mode;
  createdBy?: string;
  createdDate?: DateTime;

  constructor(opts?: Partial<TenderRequest>) {
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.rateQuoteId != null) {
      this.rateQuoteId = opts.rateQuoteId;
    }
    if (opts?.tenderMethod != null) {
      if (typeof opts?.tenderMethod === 'string') {
        this.tenderMethod = TenderMethod[opts.tenderMethod];
      } else {
        this.tenderMethod = opts.tenderMethod;
      }
    }
    if (opts?.tenderConfigOptions != null) {
      this.tenderConfigOptions = opts.tenderConfigOptions;
    }
    if (opts?.tenderResponse != null) {
      this.tenderResponse = new TenderResponse(opts.tenderResponse);
    }
    this.expirationDate = loadLuxonDateTime(opts?.expirationDate);
    if (opts?.status != null) {
      if (typeof opts?.status === 'string') {
        this.status = TenderStatus[opts.status];
      } else {
        this.status = opts.status;
      }
    }
    if (opts?.carrier != null) {
      this.carrier = opts.carrier;
    }
    if (opts?.brokeredCarrier != null) {
      this.brokeredCarrier = opts.brokeredCarrier;
    }
    if (opts?.mode != null) {
      this.mode = opts.mode;
    }
    if (opts?.createdBy != null) {
      this.createdBy = opts.createdBy;
    }
    this.createdDate = loadLuxonDateTime(opts?.createdDate);
  }

  get isInProgress(): boolean {
    return this.status === TenderStatus.AWAITING_RESPONSE;
  }

  get isExpired(): boolean {
    return this.status === TenderStatus.EXPIRED;
  }
}
